module.exports =
  ENV: 'preproduction'
  baseApiUrl: 'https://api.preprod.salony.com'
